import React, {Component} from 'react';
import styled from 'styled-components';
import media from '../MediaQueries.js';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button, DropdownToggle, NavDropdown, Dropdown, DropdownMenu, DropdownItem} from 'reactstrap';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import scrollToElement from 'scroll-to-element';

export default class MyNavbarCollapse extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    toggleIsOpen: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    cartItemCount: PropTypes.number.isRequired,
    cartPriceTotal: PropTypes.number.isRequired
  }

  constructor(props) {
    super(props);

    this.state = {
      shopIsOpen: false,
      aboutIsOpen: false
    };
  }
  toggleDropdownStatesOff = () => {
    this.setState({
      shopIsOpen: false,
      aboutIsOpen: false
    });
  }
  toggleShop = () => {
    this.setState({
      shopIsOpen: !this.state.shopIsOpen,
      aboutIsOpen: false
    });
  }
  toggleAbout = () => {
    this.setState({
      shopIsOpen: false,
      aboutIsOpen: !this.state.aboutIsOpen
    });
  }

  aboutOurCandlesClick = () => {
    if(this.props.currentRoute.pathname == "/aboutOurCandles") {
      this.scrollToSection("AboutOurCandlesSectionID", -115);
    }
  }
  aboutUsClick = () => {
    if(this.props.currentRoute.pathname == "/aboutUs") {
      this.scrollToSection("AboutUsSectionID", -115);
    }
  }

  scrollToSection = (idToScrollTo, offsetNum) => {
    let navigateTo = document.querySelector("#" + idToScrollTo);

    scrollToElement(navigateTo, {
      offset: offsetNum,
      align: "top",
      duration: 1000
    });
  }


  render() {
    return (
        <Collapse_s isOpen={this.props.isOpen} navbar>
          <Nav className="ml-auto" navbar >
            <NavItemNoDisplay768>
                <NavLink onClick={this.props.toggleIsOpen} >
                    <Span_Menu>Menu</Span_Menu>
                    <Img_CloseMenu src={require("../media/tinyX.png")} ></Img_CloseMenu>
                </NavLink>
            </NavItemNoDisplay768>

            <NavItemNoDisplay768>
                <NavLink tag={Link} to="/">
                    <Span_NavLinkTitle>Home</Span_NavLinkTitle>
                </NavLink>
            </NavItemNoDisplay768>
          
          { /****  Store Dropdown ****/ }
          <Dropdown isOpen={this.state.shopIsOpen} toggle={this.toggleShop}
                    onMouseEnter={this.toggleShop} onMouseLeave={this.toggleDropdownStatesOff}>
            <DropdownToggle_s nav caret dropdownOpen={this.state.shopIsOpen} >
                    <Span_NavLinkTitle><b>Shop</b></Span_NavLinkTitle>
            </DropdownToggle_s>
            <DropdownMenu>
              <DropdownItem header>Shop Candle Products</DropdownItem>

              <DropdownItem tag={Link} to="/Shop">
                    <Span_NavLinkTitle>Shop All Candle Products</Span_NavLinkTitle>
              </DropdownItem>

              <DropdownItem tag={Link} to="/Shop/new">
                    <Span_NavLinkTitle>Shop New Scents</Span_NavLinkTitle>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>

          {/**** About Dropdown ****/}
          <Dropdown isOpen={this.state.aboutIsOpen} toggle={this.toggleAbout}
                    onMouseEnter={this.toggleAbout}  onMouseLeave={this.toggleDropdownStatesOff}>
            <DropdownToggle_s nav caret dropdownOpen={this.state.aboutIsOpen} >
                  <Span_NavLinkTitle>About</Span_NavLinkTitle>
            </DropdownToggle_s>
            <DropdownMenu>
              <DropdownItem header>Get to know more</DropdownItem>
              <DropdownItem tag={Link} to="/aboutOurCandles" onClick={this.aboutOurCandlesClick} >
                  <Span_NavLinkTitle>About Our Candles</Span_NavLinkTitle>
              </DropdownItem>
              <DropdownItem tag={Link} to="/aboutUs" onClick={this.aboutUsClick}>
                  <Span_NavLinkTitle>About Us</Span_NavLinkTitle>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>

          <NavItem>
            <NavLink tag={Link} to="/Locator">
                <Span_NavLinkTitle>Locations</Span_NavLinkTitle>
            </NavLink>
          </NavItem>

          <NavItem>
            <NavLink tag={Link} to="/Contact">
                <Span_NavLinkTitle>Contact</Span_NavLinkTitle>
            </NavLink>
          </NavItem>

          <div style={{display: "none"}} id="logoutMock" className="snipcart-user-logout"></div>
          <div style={{display: "none"}} id="loginMock" className="snipcart-user-profile"></div>

          <NavItem_Profile>
            {
              this.props.userLoggedIn && typeof(this.props.user) !== "undefined" && this.props.user !== null
              ?
              <div>
                <span onClick={this.props.loggedInEmailClick}>Profile</span>
                <span onClick={this.props.logoutClick}>Logout</span>
              </div>
              :
              <div>
                <span onClick={this.props.loginClick}>Login</span>
              </div>
            }
          </NavItem_Profile>

          <NavItem_Cart cartItemCount={this.props.cartItemCount} className="snipcart-checkout snipcart-summary" >
              <img src={require("../media/tinyCart.png")}></img>
              <span>{this.props.cartItemCount}</span>
          </NavItem_Cart>

        </Nav>
      </Collapse_s>
    );
  }
}

const Collapse_s = styled(Collapse)`
  padding: 8px 0 0 0;
  background-color: #D0C1A0;
  ${media.md` padding-top: 0; background-color: #BCA368; `}
  
  // Top level for all nav items
  li.nav-item {
    
    height: 60px;
    line-height: 60px;
    display: table;
    width: 100%;
    border-bottom: 1px solid #BCA368;
    flex-basis: 1%;
    // If IE 10+
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) { flex-basis: auto; }

    ${media.md` 
        display: list-item; 
        width: auto; 
        border-bottom: none; 
        text-align: center;
        padding: 0 0px 0 0;
    `}

    a.nav-link {
      padding: 0;

      img {
        display: inline-block;
        float: right;
        width: 20px;
        height: 20px;
        margin: 20px 10px 0 0;
        cursor: pointer;
      }

      span {
        color: black;
        :hover {
          text-decoration-line: underline;
        }

        ${media.md` color: black; font-size: 16px; margin-left: 24px;  `}
        ${media.lg` font-size: 17px;  margin-left: 40px;  `}
        ${media.xl` font-size: 18px; margin-left: 60px;  `}
      }
    }
  }

  // DROPDOWN MENU STUFF
  .dropdown {
    background-color: #D0C1A0;

    border-bottom: 1px solid #BCA368;

    a.nav-link {
      padding: 0; 
      line-height: 60px; 
      ${media.md`  background-color: #BCA368;  span { margin-left: 24px; } `}
      ${media.lg`  span { margin-left: 40px; } `}
      ${media.xxl`  span { margin-left: 60px; } `}
    }

    ${media.md` 

        border-bottom: none; 
        text-align: center;
    `}
  }

  .dropdown-menu {
    background-color: #D0C1A0;
    position: static!important;
    transform: none!important;
    border: none;
    margin: 0;

    // If IE 10+
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) and (min-width: 768px) {
      margin-top: 60px;
    }

    a.dropdown-item {
      :active, :hover, :focus {
        background-color: #D0C1A0;
        outline: none;
      }
    }

    ${media.md` 
        position: absolute!important;
        top: unset!important;
        background-color: #D0C1A0;

      a.dropdown-item {:active, :hover, :focus { background-color: #D0C1A0; } }
    `}

    .dropdown-header {
      font-size: .9em;
      color: dimgray;
      ${media.md`   `}
    }

  }
  // END OF DROPDOWN MENU STUFF

  // Top level for all nav items with dropdowns
  li.dropdown.nav-item {
    // Edge & Firefox style
    @supports (-ms-ime-align: auto) { margin-right:15px; }
    @supports (-moz-appearance:none) { margin-right:15px;  }
  }

`;



const NavItem_Cart = styled(({ cartItemCount, ...rest }) => <NavItem {...rest} />)`

  cursor: pointer;
  padding-left: 15px;

  img { height: 70%; 

    ${media.md` 
      height: 85%;
      margin: 0;
    ` } 
  }

  span {
    position: relative;
    line-height: 20px;
    font-size: 18px;
    right: ${a => a.cartItemCount < 10 ? "24px;" : "28px;"};
    top: -4px;
    color: white;
  }


  ${media.md`
    height: 40px!important;
    margin: -14px -5px 0 98px;
    padding: 0 5px 0 0!important;

    img {
      height: 100%;
    }

    span {
      font-size: 20px;
      right: ${a => a.cartItemCount < 10 ? "-2px;" : "1px;"};
      top: -63px;
    }
  `}

    // If IE 10+
    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) and (min-width: 320px) {
      span {
        top: 17px;
        right: 37px;
      }
    }

    @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) and (min-width: 768px)  {
      span {
        top: 10px;
        right: 28px;
      }
    }
`;

const NavItem_Profile = styled(NavItem)`
  div {
    padding-left: 15px;
    

    //
    span {
        font-size: 18px;
        color: #8A572A;
        cursor: pointer;
        position: absolute;
        line-height: 20px;
        margin: 22px 0 0 0;
        left: 16px;
        font-weight: bold;

        :hover {
          color: green;
        }
    }

    span:nth-child(2) {
      left: 90px;

      :hover {
        color: red;
      }
    }
    
    /* This was 'hi'
    span:nth-child(3) {
      color: yellow;
      font-size: 16px;
      cursor: default;
      top: 25px;
      position: static;
    }
    */
  }

  ${media.md`
    div {
      position: relative;
      padding: 0;
      
      // Login
      span {
        top: 45px;
        left: 40px;
        margin: 0;
        font-size: 14px;
      }

      span:nth-child(2) {
        left: 100px;
      }
      
      /* This was 'hi'
      span:nth-child(3) {
        position: absolute;
        color: yellow;
        font-size: 16px;
        cursor: default;
      }
      */
    }
  `}

  ${media.lg` margin-left: 30px; div { span {font-size: 16px;} } `}

  ${media.xl`
    div {
      margin-left: 40px;

      span {
        font-size: 17px;
        left: -20px;
      }
      span:nth-child(2) {
        left: 50px;
      }
    }
  `}

`;

const NavItemNoDisplay768 = styled(NavItem)` ${media.md` display: none!important; `}; `;

const Span_Menu = styled.span`
  color: red;
  margin-left: 16px;
`;
const Img_CloseMenu = styled.img`
  cursor: pointer;
`;

const Span_NavLinkTitle = styled.span`
  cursor: pointer;
  margin-left: 16px;
  color: black;
  font-family: 'Raleway';
  font-size: 16px;

  ${media.lg` font-size: 17px; `}
  ${media.xl` font-size: 18px; `}

  :hover {
    text-decoration-line: underline;
  }

`;

const DropdownToggle_s = styled(({ dropdownOpen, ...rest }) => <DropdownToggle {...rest} />)`
  ::after {
      border-top-width: ${a => a.dropdownOpen ? "0!important" : "4.3px!important;"};
      border-bottom: ${a => a.dropdownOpen ? "4.3px solid black!important" : ""};
      color: black;
      float: right;
      margin-top: 30px;
      margin-right: 10px;

      ${media.md` 
          margin: 2px 0 0 6px!important;
          float: none;
          color: black;
          border-top-width: ${a => a.dropdownOpen ? "0!important" : "4.3px!important;"};
          border-bottom: ${a => a.dropdownOpen ? "4.3px solid black!important" : ""};

          // Edge & Firefox style
          @supports (-ms-ime-align: auto) { position: absolute; top: 30px; }
          @supports (-moz-appearance:none) { position: absolute; top: 30px;  }
      `}
  }
`;

const DropdownItemHeader = styled(DropdownItem)`

`;


// WEBPACK FOOTER //
// ./src/components/MyNavbarCollapse.js